import { FormSelect } from '@components/form';
import { MenuItem } from '@mui/material';
import * as yup from 'yup';

export const volumePermissionSchema = yup
  .string()
  .oneOf(['write', 'read'])
  .required('Permission is required');

export const VolumePermissionField = () => {
  return (
    <FormSelect label="Permission" name="permission">
      <MenuItem value="write">Write</MenuItem>
      <MenuItem value="read">Read</MenuItem>
    </FormSelect>
  );
};
